import { jsPDF } from "jspdf";
import { logoBase64 } from "@/utils/reusables/pdfLogo";
import { eSignatureTin } from "@/utils/reusables/eSignature-tin";
import { eSignatureNette } from "@/utils/reusables/eSignature-nette";
import { eSignatureDoc } from "@/utils/reusables/eSignature-doc";
import { inject } from "vue";

export default function pdfGenerateHandler() {
  const moment = inject("$moment");
  const store = inject("$store");

  const exportPDF = (decline) => {
  const ifRegularMode = !decline.admin ? true : false;
  const eSignatureUser = !decline.admin
    ? store.state.userDetails.name
    : decline.admin.name;

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const marginX = 20;
  const maxWidth = pageWidth - marginX * 2;

  // Logo
  const logoWidth = 95;
  const logoHeight = 25;
  const logoX = (pageWidth - logoWidth) / 2;
  doc.addImage(logoBase64, "PNG", logoX, 10, logoWidth, logoHeight);

  // Date
  doc.setFontSize(11);
  doc.setFont("Georgia", "normal");
  doc.text(
    `${moment(decline.declineddate).isValid() ? moment(decline.declineddate).format("LL") : moment().format("LL")}`
,
    marginX,
    45
  );

  // Member and company
  doc.setFont("Georgia", "bold");
  doc.text(`${decline.membername}`, marginX, 64);

  doc.setFont("Georgia", "normal");
  doc.text(`${decline.company}`, marginX, 70);

  // Greeting
  const yDear = 90;
  const memberName = decline.membername.split(",")[0].trim() + ",";
  const titleText = `Mr/Mrs. ${memberName}`;
  doc.text("Dear ", marginX, yDear);
  doc.setFont("Georgia", "bold");
  const dearWidth = doc.getTextWidth("Dear ");
  doc.text(titleText, marginX + dearWidth, yDear);
  const titleWidth = doc.getTextWidth(titleText);
  doc.setFont("Georgia", "normal");
  doc.text("", marginX + dearWidth + titleWidth, yDear);

  // Intro
  const yGreet = 102;
  doc.text("Greetings from ", marginX, yGreet);
  doc.setFont("Georgia", "bold");
  const greetWidth = doc.getTextWidth("Greetings from ");
  doc.text("IMS WELLTH CARE, INC.", marginX + greetWidth, yGreet);

  // Reference line
  const yText = 112;
  const requestDate = moment(decline.requestdate).format("LL");
  const beforeDate =
    "This is in reference to your request for reimbursement, which we have received on ";
  const afterDate = " with the following details:";
  const fullText = beforeDate + requestDate + afterDate;

  const wrappedLines = doc.splitTextToSize(fullText, maxWidth);
  let yOffset = yText;
  wrappedLines.forEach((line) => {
    const indexStart = line.indexOf(requestDate);
    if (indexStart >= 0) {
      const partBefore = line.slice(0, indexStart);
      const partAfter = line.slice(indexStart + requestDate.length);
      doc.setFont("Georgia", "normal");
      doc.text(partBefore, marginX, yOffset);
      const widthBefore = doc.getTextWidth(partBefore);
      doc.setFont("Georgia", "bold");
      doc.text(requestDate, marginX + widthBefore, yOffset);
      const widthDate = doc.getTextWidth(requestDate);
      doc.setFont("Georgia", "normal");
      doc.text(partAfter, marginX + widthBefore + widthDate, yOffset);
    } else {
      doc.setFont("Georgia", "normal");
      doc.text(line, marginX, yOffset);
    }
    yOffset += 6;
  });

  // Availment info
  const availmentText = `${decline.availmenttype} availment in ${
  decline.providername
}; Dated: ${moment(decline.admitdate).format("LL")}.`;

const wrappedText = doc.splitTextToSize(availmentText, pageWidth - marginX * 2 - 20); // Add 20 for indent
doc.text(wrappedText, marginX, yOffset + 10);

  // Remarks
  const remarksY = yOffset + 25;
  const remarksText = decline.declinedremarks || "-";
  const wrappedRemarks = doc.splitTextToSize(remarksText, maxWidth);
  const lineHeight = 6;
  wrappedRemarks.forEach((line, index) => {
    doc.text(line, marginX, remarksY + index * lineHeight);
  });

  const remarksHeight = wrappedRemarks.length * lineHeight;
  const afterRemarksY = remarksY + remarksHeight + 40;

  // Rejection message
  doc.text(
    `We regret to inform you that your claim has been denied due to the above mentioned reason/s.`,
    marginX,
    afterRemarksY
  );

  // === Dual Signature Block ===
  const sigStartY = afterRemarksY + 15;

  // Left - Very truly yours
  doc.setFont("Georgia", "normal");
  doc.text(`Very truly yours,`, marginX, sigStartY);

  if (eSignatureUser === "Kristine Culnin" || eSignatureUser === "IWC Dev") {
    doc.addImage(eSignatureTin, "JPG", marginX, sigStartY + 1, 30, 20);
  } else {
    doc.addImage(eSignatureNette, "JPG", marginX, sigStartY + 1, 30, 20);
  }

  doc.setFont("Georgia", "bold");
  doc.text(
    `${ifRegularMode ? store.state.userDetails.name : decline.admin.name}`,
    marginX,
    sigStartY + 22
  );
  doc.text(
    `${ifRegularMode ? store.state.userDetails.role : decline.admin.role}`,
    marginX,
    sigStartY + 27
  );

  // Right - Noted by & Doctor
  const notedByText = "Noted by:";
  const notedByX = pageWidth - marginX - doc.getTextWidth(notedByText);
  doc.setFont("Georgia", "normal");
  doc.text(notedByText, notedByX - 60.2, sigStartY);

  if (decline.declinedverify) {
    doc.addImage(
      eSignatureDoc,
      "JPG",
      pageWidth - marginX - 53,
      sigStartY + 1,
      30,
      20
    );
  }

  const doctorName = `MELANIE B. ARANTE-LLAGAS, M.D., FPCP`;
  const doctorTitle = `Medical Director`;
  const doctorNameX = pageWidth - marginX - doc.getTextWidth(doctorName);
  const doctorTitleX = pageWidth - marginX - doc.getTextWidth(doctorTitle);
  doc.setFont("Georgia", "bold");
  doc.text(doctorName, doctorNameX, sigStartY + 22);
  doc.text(doctorTitle, doctorTitleX - 49.5, sigStartY + 27);

  // Transaction number
  doc.setFontSize(8);
  doc.setFont("Georgia", "normal");
  doc.text(`${decline.transactionnumber}`, marginX, sigStartY + 44);

  // Footer
  const footerY = pageHeight - 12;
  const footerText1 =
    "14th Floor Manila Astral Tower, Taft Avenue corner Padre Faura Street, Ermita, Manila";
  const footerText2 =
    "Tel. Nos. 528-0480; 536-4728; 526-6940; 525-5366; 523-3319";

  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(marginX, footerY - 6, pageWidth - marginX, footerY - 6);

  doc.setFont("Georgia", "normal");
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);

  const footerText1Width = doc.getTextWidth(footerText1);
  const footerX1 = (pageWidth - footerText1Width) / 2;
  doc.text(footerText1, footerX1, footerY);

  const footerText2Width = doc.getTextWidth(footerText2);
  const footerX2 = (pageWidth - footerText2Width) / 2;
  doc.text(footerText2, footerX2, footerY + 4);

  // Save
  doc.save(`${decline.membername}.pdf`);
};



  return {
    exportPDF,
  };
}
